angular.module('tgaAdmin').directive('uiSelectDisableBackspace', () => ({
  restrict: 'A',
  require: 'uiSelect',
  link($scope, $element, attrs, $select) {
    $select.focusInput.keydown((e) => {
      const backspaceKeyPressed = e.keyCode === 8;
      if (backspaceKeyPressed) {
        e.stopImmediatePropagation();
      }
    });
    // eslint-disable-next-line no-underscore-dangle
    const eventListeners = $._data($select.focusInput[0], 'events');
    eventListeners.keydown.unshift(eventListeners.keydown.pop());
  },
}));
